import { useQuery } from '@apollo/client';
import { BRAINTREE_CLIENT_TOKEN_QUERY } from './braintreeClientToken.rest';

export const useBraintreeClientToken = () => {
  const { data, ...rest } = useQuery(BRAINTREE_CLIENT_TOKEN_QUERY);
  return { token: data?.braintreeClientToken.token, ...rest };
};
